import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function Consultations() {
  const { fq } = useApp();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/consultations${fq ? `?${fq}` : ""}`).then(({ data }) => setRows(data)).catch(() => {});
  }, [fq]);

  return (
    <div className="space-y-5" data-testid="consultations-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-primary">Clinical records</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Consultations</h1>
      </div>
      <Card className="shadow-sm">
        <CardContent className="p-0">
          <Table data-testid="consultations-table">
            <TableHeader><TableRow>
              <TableHead>Date</TableHead><TableHead>Patient</TableHead><TableHead>Diagnosis</TableHead>
              <TableHead>ICD</TableHead><TableHead>Rx</TableHead><TableHead className="text-right">Action</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={6} className="text-center py-10 text-sm text-muted-foreground">
                  No consultations recorded yet.
                </TableCell></TableRow>
              )}
              {rows.map((c) => (
                <TableRow key={c.id} data-testid={`consultation-row-${c.id}`} className="hover:bg-muted/50">
                  <TableCell className="text-xs font-mono">{new Date(c.created_at).toLocaleString()}</TableCell>
                  <TableCell className="font-medium">{c.patient_name}
                    <span className="block text-xs font-mono text-muted-foreground">{c.patient_uhid}</span>
                  </TableCell>
                  <TableCell>{c.diagnosis}</TableCell>
                  <TableCell className="font-mono text-xs">{c.icd_code || "—"}</TableCell>
                  <TableCell className="font-mono text-xs">{c.prescription_number || "—"}</TableCell>
                  <TableCell className="text-right">
                    <Button size="sm" variant="outline" data-testid={`open-consultation-record-${c.id}`}
                      onClick={() => nav(`/consultation/${c.id}`)}>Open</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
